import { useMutation } from 'react-query';
import { AxiosResponse } from 'axios';

// configs
import { API } from 'configs/api';
// types
import { ICreateStatsLinks } from './types';

const createStatsLinksMutation = async ({
  data,
  shortUrl,
}: {
  data: ICreateStatsLinks;
  shortUrl: string;
}) => {
  if (!shortUrl) {
    throw new Error('Invalid url');
  }
  const response: AxiosResponse = await API.post(
    `/playback/${shortUrl}/links`,
    data
  );

  return response.data;
};

export const useCreateStatsLinksMutation = () => {
  return useMutation(createStatsLinksMutation);
};
